import React from 'react';
import Typography from '@material-ui/core/Typography';
import { splitTextByDotAndUnderscore } from 'UI/utils';

import { useStyles } from '../styles';

/**
 * @param {Object} props
 * @param {string} props.label
 * @param {boolean} props.split
 */
const Label = ({ label, split }) => {
  const classes = useStyles();

  return label ? (
    <Typography variant="body1" classes={{ body1: classes.textLight }} gutterBottom>
      {split ? splitTextByDotAndUnderscore(label) : label}:&nbsp;
    </Typography>
  ) : null;
};

export default Label;
